/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Item } from '../item';
import { TabDescription } from '../tab-description';
import { SystemInfo } from '../system-info';
import { SysqueElectricalState } from '@hcworkspace/sysque/toolbelt/feature';
import { TooltipItem } from '../tooltip-item';
import { PastedItemsInfo } from 'libs/sysque/toolbelt/feature/src/lib/models/pasted-items-info';

export interface IManageModePanelFrameFacade {
  selectSystemsForDestination(): Observable<SystemInfo[]>;
  selectSystemsForSource(): Observable<SystemInfo[]>;
  selectFittingForDestination(): Observable<Item[]>;
  selectFittingForSource(): Observable<Item[]>;
  getDockedState(): SysqueElectricalState;
  selectSystems(): Observable<SystemInfo[]>;
  updateSystemList(): void;
  getAddFittingState(): SysqueElectricalState;
  getManageModeSourceState(): SysqueElectricalState;
  getManageModeDestinationState(): SysqueElectricalState;
  selectCategoriesForSourceSystem(): Observable<TabDescription[]>;
  selectCategoriesForDestinationSystem(): Observable<TabDescription[]>;
  notifyGetFittingsListAction(system: string, value: string): Observable<Item[]>;
  notifyGetCategoryListAction(systemName: string): Observable<TabDescription[]>;
  updateLocalStorage(key: string, value: any): any;
  sendPopupRoutingAction(route: string, width: number, height: number): any;
  saveChanges(Fitting2Manage: string): void;
  resetFittingModeState(): void;
  resetManageState(): void;
  resetDockedState(): void;
  getTooltipItemInfo(item: Item, category: string): TooltipItem[];
  getFittings(systemName: string, categoryName: string): Observable<Item[]>;
  getLocalStorageUpdate(): Observable<string>;
  executePasteItemsAction(replaceItems: PastedItemsInfo[]): void;
  checkForDuplicateItemsInDestination(items: PastedItemsInfo[]): Promise<PastedItemsInfo[]>;
  checkForDuplicateItemsInDestForCopyCategory(items: PastedItemsInfo[]): Observable<boolean>;
  logicToExecuteForCopyCategory(isReplace: boolean): void;
  getLocalStorageForDuplicateKeyStatus(): boolean;
  setManageModeDestinationState(state: SysqueElectricalState): void
  openHangerSpecification(): void;
  logicToExecuteForHangerCopyCategory(items: PastedItemsInfo[], isSetUp: boolean): void;
}

export const MANAGE_MODE_PANEL_FRAME_FACADE_TOKEN = new InjectionToken<IManageModePanelFrameFacade>(
  'MANAGE_MODE_PANEL_FRAME_FACADE_TOKEN'
);